import { useMutation } from '@tanstack/react-query';

import { verifyMfaLogin } from '../api/adminAuthApi';

// PARA-151, AC-5: шаг 2 логина — верификация TOTP-кода по mfa_token.
export function useVerifyMfaLogin() {
  return useMutation({
    mutationFn: ({ mfaToken, totpCode }: { mfaToken: string; totpCode: string }) =>
      verifyMfaLogin(mfaToken, totpCode),
  });
}
